import React from 'react';
import {connect} from "react-redux";
import {projectCalendarSelector, projectStatusSelector, projectViewSelector} from "./selectors";
import {NavLink} from "react-router-dom";
import URI from 'urijs';
import * as R from 'ramda';
import moment from "moment";
import PropTypes from "prop-types";
import Sticky from 'react-sticky-fill'
import {Button, Card, Col, DatePicker, Divider, Input, Popover, Row, Select} from 'antd';
import {createProject, deleteProject, getProject, getProjects, getProjectsIndex, leaveProject} from "../../actions/projects";
import {getProjectCalendarReport, getProjectStatusReport} from "../../actions/reports";
import {buildSummaryChartData} from "../../projections";
import CompanySmall from "../Boilerplate/CompanySmall";
import DateDisplay from "../Boilerplate/DateDisplay";
import ExpandedList from "../Boilerplate/ExpandedList";
import SearchBox from "../Boilerplate/SearchBox";
import UserSmall from '../Boilerplate/UserSmall';
import {CodeTag} from "../Boilerplate/CodeTag";
import {Schedule} from "../Boilerplate/Schedule";
import {canDelete} from "../Boilerplate/permissions";
import {separatorJoin} from "../Boilerplate/utilities";
import AddressLink from "../AddressLink";
import SummaryChart from "./SummaryChart";
import {setViewPath} from "../../actions/view";
import {DeleteButton} from "./DeleteButton";
import {UnfollowButton} from "./UnfollowButton";

const filterState = {
  sortBy: 'datecreated',
  sortOrder: 'descending',
  dateRange: [null, null],
  statusFilter: null,
  limit: 20,
  filterKeys: null,
};

const initialState = {
  ...filterState,
  calendarDate: moment(),
  calendarMode: 'month',
  loading: true,
};

const mapFiltersStateToUrl = (filters) => {
  let status;
  const { sortBy: sortby, sortOrder: order, size: limit, statusFilter, filterKeys: search } = { ...filters };
  if (statusFilter) {
    status = statusFilter;
  }
  return { ...filters, sortby, order, limit, status, search };
};

const ProjectHeading = () => <Row className="bid-listing-heading text-column" gutter={18}>
  <Col xs={8} sm={9} md={10} lg={7}>Project Name</Col>
  <Col xs={4} sm={3} lg={2}>Proj. #</Col>
  <Col xs={6} lg={5}>Entered By</Col>
  <Col xs={0} lg={3}>Start Date</Col>
  <Col xs={0} lg={3}>Created</Col>
  <Col xs={0} sm={6} md={5} lg={4}>Status</Col>
  <Col xs={6} sm={0} className='status-column-right'>Status</Col>
</Row>;

const ProjectItemHead = ({ project, onFilter, onDelete, onLeave }) => {
  let options = [];
  options.push(canDelete(project) ?
    <DeleteButton fauxKey={'delete-'+project.resource.id} icon='delete' title='Delete Project'
                  document={project} onDelete={onDelete}/> :
    <UnfollowButton fauxKey={'leave-'+project.resource.id} type='close-circle' title='Unfollow Project'
                    project={project} onLeave={onLeave}/>);
  return <Row className={'bid-listing-content'} type={'flex'} justify='space-between' gutter={18}>
    <Col xs={8} sm={9} md={10} lg={7} className="text-column collapse-ellipses">
      <NavLink to={'/projects/' + project.resource.id}>{project.resource.name}</NavLink>
    </Col>
    <Col xs={4} sm={3} lg={2} className='text-column'><span>{project.resource.number}</span></Col>
    <Col xs={6} lg={5} className='text-column'>
      <CompanySmall id={project.resource.ownercompanyid}/>
    </Col>
    <Col xs={0} lg={3}>
      <DateDisplay date={project.resource.dateopened}/>
    </Col>
    <Col xs={0} lg={3}>
      <DateDisplay date={project.resource.datecreated}/>
    </Col>
    <Col xs={0} sm={3} md={2}>
      <div className='status-column'>
        <CodeTag
          code={project.resource.status}
          table='projectstatus'
          onClick={() => onFilter(project.resource.status)}
        />
      </div>
    </Col>
    <Col xs={0} sm={3} lg={2}>
      <div className='actions-column status-column status-column-right'>
        <div>
          {separatorJoin(options, <br/>)}
        </div>
      </div>
    </Col>
    <Col xs={6} sm={0}>
      <div className='actions-column status-column status-column-right'>
        <div>
          <CodeTag
            code={project.resource.status}
            table='projectstatus'
            onClick={() => onFilter(project.resource.status)}
          />
        </div>
        <div>
          {separatorJoin(options, <br/>)}
        </div>
      </div>
    </Col>
  </Row>;
};

ProjectItemHead.propTypes = {
  project: PropTypes.any,
  onDelete: PropTypes.func,
  onLeave: PropTypes.func,
  onFilter: PropTypes.func,
};

const ProjectDetails = ({project}) => <Row>
  <Col span={12}>
    <Row>
      <strong className='details-heading'>Start Date</strong>
      <DateDisplay className='details-data' date={project.resource.dateopened}/>
    </Row>
    <Row>
      <strong className='details-heading'>Created On</strong>
      <DateDisplay className='formatted-text details-data' date={project.resource.datecreated}/>
      <strong className='details-heading'>Entered By</strong>
      <UserSmall className='formatted-text details-data' id={project.resource.createdbyuserid}/>
      <strong className='details-heading'>Project Lead</strong>
      <UserSmall className='details-data' id={project.resource.owneruserid}/>
    </Row>
  </Col>
  <Col span={12}>
    <Row>
      <strong className='details-heading'>Site Address</strong>
      <AddressLink address={project.resource.address ? {
        street: project.resource.address,
        suite: project.resource.address2,
        city: project.resource.city,
        state: project.resource.state,
        zip: project.resource.zip
      } : null}/>
    </Row>
    <Row>
      <strong className='details-heading'>Architect</strong>
      <p className='formatted-text details-data'>{project.resource.architectname}</p>
      <strong className='details-heading'>Engineer</strong>
      <p className='formatted-text details-data'>{project.resource.engineername}</p>
      <strong className='details-heading'>Site Owner</strong>
      <p className='formatted-text details-data'>{project.resource.siteownername}</p>
    </Row>
  </Col>
</Row>;

ProjectDetails.propTypes = { project: PropTypes.any };

const ProjectItemBody = ({ project }) => <div className='bid-listing-full-content'>
  <div className='bid-listing-watermark'>
    <img src={`/static/media/logos/${project.resource.createdbycompanyid}`} alt=''/>
  </div>
  <Col className="bid-listing-full-content-text">
    <Row gutter={32}>
      <Col span={24}>
        <NavLink to={'/projects/' + project.resource.id}><h1 className='list-title'>{project.resource.name}</h1></NavLink>
        <hr/>
      </Col>
      <Col xs={0} sm={14} className='details-info'>
        <ProjectDetails project={project}/>
      </Col>
      <Col className='details-description'>
        <p className='formatted-text'><strong className='details-heading'>Description</strong></p>
        <p className='formatted-text text-wrap'>{project.resource.description}</p>
      </Col>
      <Col xs={24} sm={0}>
        <ProjectDetails project={project}/>
      </Col>
    </Row>
  </Col>
</div>;

ProjectItemBody.propTypes = { project: PropTypes.any };

class ProjectList extends React.Component {
  constructor(props) {
    super(props);
    const filters = this.mapFiltersUrlToState(new URI().query(true));
    this.state = { ...initialState, ...filters };
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }

  componentDidUpdate(prevProps) {
    const { projectsindex: index } = this.props;
    const { projectsindex: prevIndex } = prevProps;
    if (index !== prevIndex) {
      this.setState({ loading: false })
    }
  }

  mapFiltersUrlToState = (filters) => {
    const { sortby: sortBy, order: sortOrder, from, to, status, limit: size, search: filterKeys } = { ...filters };
    let result = {};
    if (sortBy) result.sortBy = sortBy;
    if (sortOrder) result.sortOrder = sortOrder;
    if (from || to) result.dateRange = [moment(from), moment(to)];
    if (status) result.statusFilter = status;
    if (size) result.size = size;
    if (filterKeys) result = { ...result, filterKeys };
    return result;
  };

  updateFilters = (filters, remount = true, reload = true) => {
    this.setState({ loading: reload });

    filters = this.checkFilters(filters);

    this.props.history.push({ search: URI().search(filters).search() });

    const { onMount } = this.props;
    remount && onMount && onMount();
  };

  setFilter = (phrase) => {
    this.setState({ filterKeys: phrase });

    this.updateFilters({ filterKeys: phrase });
  };

  setSortBy = (sortBy) => {
    this.setState({ sortBy });

    this.updateFilters({ sortBy });
  };

  setSortOrder = (sortOrder) => {
    this.setState({ sortOrder });

    this.updateFilters({ sortOrder });
  };

  clearSort = () => {
    const { sortBy, sortOrder } = filterState;
    this.setState({ sortBy, sortOrder });
    this.updateFilters({ sortBy, sortOrder });
  };

  setDateRange = (range) => {
    this.setState({ calendarDate: range[0] });

    this.updateFilters({ dateRange: range });
  };

  checkFilters = (overrides, includeSearch = true) => {
    const urlFilters = this.mapFiltersUrlToState(new URI().query(true));
    let { sortby, order, dateRange, status, statusFilter, limit, search } = mapFiltersStateToUrl({ ...this.state, ...urlFilters, ...overrides });
    const [from, to] = dateRange;

    let newFilters = {};
    if (sortby !== filterState.sortBy) newFilters.sortby = sortby;
    if (order !== filterState.sortOrder) newFilters.order = order;
    if (dateRange !== filterState.dateRange) {
      if (from) newFilters.from = moment(from).startOf('day').format();
      if (to) newFilters.to = moment(to).endOf('day').format();
    }
    if (statusFilter !== filterState.statusFilter && status) newFilters.status = status;
    if (limit && limit !== filterState.limit) newFilters.limit = limit;
    if (includeSearch && search && search !== filterState.filterKeys) newFilters.search = search;

    return newFilters;
  };

  clearDateRange = () => this.setDateRange(filterState['dateRange']);

  setFilterCode = (code) => {
    this.setState({
      statusFilter: code
    });

    this.updateFilters({ statusFilter: code });
  };

  clearFilterCode = () => {
    this.setFilterCode(null);
  };

  handleGraphClick = (e) => {
    let category = e.name;
    let { statusSummary } = this.props;
    let chosen = statusSummary.find(x => x.key.name === category);
    if (chosen) {
      this.setFilterCode(chosen.key.code);
    }
  };

  handleCalendarChange = (day, mode, update = true) => {
    let dateRange;

    this.setState({
      calendarMode: mode,
      calendarDate: day
    });

    if (!update) return;

    if (mode === 'year') {
      dateRange = [moment(day).startOf('month'), moment(day).endOf('month')];
    } else {
      dateRange = [day, day];
    }

    this.setState({ dateRange: dateRange });
    this.updateFilters({ dateRange }, dateRange !== this.state.dateRange, dateRange !== this.state.dateRange);
  };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  handlePageChange = (page, size) => {
    const { onPageChange, projectsindex } = this.props;
    this.setState({ page, size });
    if (size !== this.state.size) this.updateFilters({ size }, false, false);
    onPageChange && onPageChange(page, size, projectsindex);
  };

  clearFilters = () => {
    this.setState(filterState);
    this.updateFilters(filterState);
  };

  render() {
    let { projectsindex, projects, statusSummary, datesSummary, onNew } = this.props;
    const {
      sortBy,
      sortOrder,
      dateRange,
      calendarDate,
      statusFilter
    } = this.state;

    projects = projects || [];

    const { sortby, order, from, to, search } = this.checkFilters();
    const hasRange = from || to;
    const isSorted = sortby || order;

    const appliedFilters = !!isSorted + !!hasRange + !!statusFilter + !!search;

    let chartData = buildSummaryChartData(statusSummary);

    const isEmpty = obj => { for (let x in obj) { return false; } return true; };

    const renderFilterControls = () => <div className='bid-listing-control'>
      {statusFilter &&
      <CodeTag
        className='control-clear'
        closable
        onClose={this.clearFilterCode}
        code={statusFilter}
        table='projectstatus'
      />
      }
      <Input.Group compact className='control-box'>
        <div className='ant-input-group-addon ant-input-group-compact-addon control-filter'><span>Sort By</span>
        </div>
        <Select onChange={(value) => this.setSortBy(value)} value={sortBy} defaultValue={sortBy || 'datecreated'}
                dropdownStyle={{ zIndex: 1033 }}>
          <Select.Option value='datecreated'>Date Created</Select.Option>
        </Select>
        <Select onChange={(value) => this.setSortOrder(value)} value={sortOrder}
                defaultValue={sortOrder || 'descending'} dropdownStyle={{ zIndex: 1033 }}>
          <Select.Option value='ascending'>Ascending</Select.Option>
          <Select.Option value='descending'>Descending</Select.Option>
        </Select>
      </Input.Group>
      <DatePicker.RangePicker
        className='control-box'
        value={dateRange}
        onChange={(range) => this.setDateRange(range)}
        format='MM/DD/YYYY'
      />
    </div>;

    return (
      <Row className={'bid-listing'} type={'flex'} justify={'center'} gutter={16}>
        <Col xl={0} md={12} xs={24} className='overview-top'>
          <Card id='top-status'>
            <div className='top-status-container'>
              <div className='top-status-container-inner-translate'>
                <SummaryChart
                  data={chartData}
                  title='Projects by Status'
                  onClick={this.handleGraphClick}
                />
              </div>
            </div>
          </Card>
        </Col>
        <Col xl={0} md={12} xs={24} className='overview-top'>
          <Card>
            <Schedule value={calendarDate} onChange={this.handleCalendarChange} callouts={datesSummary}/>
          </Card>
        </Col>
        <Col xl={18} xs={24}>
          <Card>
            <div className='bid-listing-header'>
              <h1>Projects</h1>
              <SearchBox
                className='control-box control-search'
                placeholder='Search projects...'
                onChange={this.setFilter}
                defaultValue={this.state.filterKeys}
              />
            </div>
            <div>
              <Divider/>
              <ExpandedList
                index={projectsindex}
                serverSidePagination
                onPageChange={this.handlePageChange}
                items={projects}
                loading={this.state.loading}
                extra={(<React.Fragment>
                  <Popover placement='bottom' content={renderFilterControls()} trigger='click'>
                    <Button icon='filter' className={(!isEmpty(this.checkFilters(null, false))) && 'background-primary-1 color-grayscale-3'}>
                      <span className='hidden inline visible-lg'>Filter</span>
                    </Button>
                  </Popover>
                  <Button className='background-primary-0 border-primary-0'
                          disabled={!this.props.projectcreator}
                          type='primary' icon='plus' onClick={onNew}>
                    <span className='hidden inline visible-lg'>New Project</span>
                  </Button>
                </React.Fragment>)}
                subExtra={<div>
                  {isSorted && <Button className={'clear-filter'} size="small" onClick={this.clearSort}>Clear Sort</Button>}
                  {search && <Button className={'clear-filter'} size="small" onClick={() => this.setFilter()}>Clear Search</Button>}
                  {hasRange && <Button className={'clear-filter'} size="small" onClick={this.clearDateRange}>Clear Calendar Filter</Button>}
                  {statusFilter && <Button className={'clear-filter'} size="small" onClick={this.clearFilterCode}>Clear Status Filter</Button>}
                  <Button className={'clear-filter'} size="small" style={{ visibility: appliedFilters <= 1 && 'hidden' }} onClick={this.clearFilters}>Clear All Filters</Button>
                </div>}
                derivedKey={item => item.resource.id}
                renderHeading={() => <ProjectHeading/>}
                renderTop={project =>
                  <ProjectItemHead project={project}
                                   onFilter={this.setFilterCode}
                                   onDelete={this.props.onDelete}
                                   onLeave={this.props.onLeave}
                  />}
                renderContent={project => <ProjectItemBody project={project}/>}
                emptyText={isEmpty(this.checkFilters(null, true)) && 'There are no projects within the last eighteen months available to you.'}
              />
            </div>
          </Card>
        </Col>
        <Col xl={6} xs={0}>
          <Sticky className='overview-right'>
            <Card>
              <SummaryChart
                data={chartData}
                title='Projects by Status'
                onClick={this.handleGraphClick}
              />
            </Card>
            <Card>
              <Schedule value={calendarDate} onChange={this.handleCalendarChange} callouts={datesSummary}/>
            </Card>
          </Sticky>
        </Col>
      </Row>
    );
  }
}

ProjectList.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.object).isRequired,
  projectsindex: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default connect(
  (state, props) => {
    return {
      projectcreator: R.view(R.lensPath(['ui', 'authData', 'createProjects']), state),
      projects: projectViewSelector(state),
      projectsindex: state.view.indexes,
      statusSummary: projectStatusSelector(state),
      datesSummary: projectCalendarSelector(state),
    };
  },
  (dispatch, props) => ({
    onMount: () => {
      const filters = new URI().query(true);
      const { limit = 20, sortby, order } = { ...mapFiltersStateToUrl(filterState), ...filters };
      // Default date filter: last 18 months
      const [from, to, filterby] = [null, null, ((filters.from || filters.to) && sortby) || 'datecreated'];
      dispatch(setViewPath(['projects']));
      dispatch(getProjectsIndex({ filterby, from, to, ...filters, sortby, order }));
      dispatch(getProjects({ filterby, from, to, ...filters, limit, sortby, order }));
      dispatch(getProjectStatusReport({ filterby, from, to, ...filters, sortby }));
      dispatch(getProjectCalendarReport({ filterby, ...filters, sortby, from, to }))
    },
    onPageChange: (page, size, index) => index.slice((page - 1) * size, page * size).forEach(e => dispatch(getProject(e))),
    onAdd: (project) => dispatch(createProject(project)),
    onDelete: (projectId) => dispatch(deleteProject(projectId)),
    onLeave: (projectId) => dispatch(leaveProject(projectId)),
    onNew: () => props.history.push('/projects/new'),
  }))(ProjectList);



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectList.js